/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Row, Col, message, Menu, Dropdown, Button } from "antd";
import Layout from "../../../layouts/MocoLayout";
import { NavigationMenuCard } from "../../../components/ui";
import { TableCard } from "../../../components/widget";
import oRest from "../../../apis/rest";
import config from "./index.config";
import "./index.scss";

const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [selectedProvince, setProvince] = useState("");
  const [provinceMenu, setProvinceMenu] = useState([]);

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}survey5agama_list_provinsi`;
      oRest
        .get(api)
        .then(({ data }) => {
          setProvinceMenu(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, []);

  const handleFilterProvinsi = (value) => {
    setProvince(value.key === "all" ? "" : value.key);
  };

  const provinceDropdownMenu = (
    <Menu onClick={handleFilterProvinsi}>
      <Menu.Item key="all">Nasional</Menu.Item>
      {provinceMenu
        ?.map((e) => e.lembaga_provinsi)
        .sort((a, b) =>
          // eslint-disable-next-line no-nested-ternary
          a > b ? 1 : b > a ? -1 : 0
        )
        .map((e) => {
          return <Menu.Item key={e}>{toPascalCase(e)}</Menu.Item>;
        })}
    </Menu>
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const api = `${API_URL}${cards.table.kegiatanDakwah.queryName}&PROVINSI=${selectedProvince}`;
        const { data } = await oRest.get(api);
        const titleCard = `Kegiatan Dakwah di ${
          selectedProvince === ""
            ? "Seluruh Provinsi"
            : `Provinsi ${selectedProvince}`
        }`;
        setCards((card) => ({
          ...card,
          table: {
            ...card.table,
            kegiatanDakwah: {
              ...card.table.kegiatanDakwah,
              content: {
                ...card.table.kegiatanDakwah.content,
                title: titleCard,
              },
              options: {
                ...card.table.kegiatanDakwah.options,
                dataSource: data.map((e, id) => ({ ...e, id })),
              },
              state: {
                data,
              },
            },
          },
        }));
      } catch (error) {
        console.log(error);
        message.error("Terjadi Kesalahan");
      }
    };
    fetchData();
  }, [selectedProvince]);

  return (
    <section id="Pendidikan">
      <Layout>
        <NavigationMenuCard
          menu={[
            { title: "Sebaran", path: "/pondok-pesantren" },
            { title: "Pendidikan", path: "/pondok-pesantren/pendidikan" },
            { title: "Dakwah", path: "/pondok-pesantren/dakwah" },
            {
              title: "Pemberdayaan Masyarakat",
              path: "/pondok-pesantren/pemberdayaan-masyarakat",
            },
            {
              title: "Penyajian dan Pencarian",
              path: "/pondok-pesantren/penyajian-pencarian",
            },
          ]}
        />
        <Row
          justify="end"
          align="top"
          gutter={[32, 24]}
          style={{ padding: "8px 0" }}
        >
          <Col>
            <Dropdown
              overlay={provinceDropdownMenu}
              overlayStyle={{ height: 300, overflowY: "auto" }}
            >
              <Button
                size="large"
                shape="round"
                style={{
                  backgroundColor: "#1B6FBA",
                  color: "#fff",
                }}
              >
                Pilih provinsi &nbsp;
                <DownOutlined />
              </Button>
            </Dropdown>
          </Col>
        </Row>
        <Row gutter={[24, 24]} style={{ padding: "8px 0" }} id="dakwah">
          <Col span={24}>
            <TableCard {...cards.table.kegiatanDakwah} />
          </Col>
        </Row>
      </Layout>
    </section>
  );
};

export default Page;
